import type { MouseEvent, ReactNode } from "react";

import { classNames, Icon } from "@alpacahq/ui/old";

interface SectionDropdownProps {
  isOpen: boolean;
  onToggleOpen: (event: MouseEvent<HTMLButtonElement>) => void;
  title: string;
  icon?: ReactNode;
  children: ReactNode;
  className?: string;
}

export const SectionDropdown = ({
  isOpen,
  onToggleOpen,
  title,
  icon,
  children,
  className,
}: SectionDropdownProps) => (
  <section className={classNames("w-full", className)}>
    <div className="flex items-center justify-between gap-4">
      <button
        type="button"
        aria-label={`${isOpen ? "Close" : "Open"} ${title} section`}
        onClick={onToggleOpen}
        className="flex items-center justify-start gap-2"
      >
        <Icon name={isOpen ? "ChevronUp" : "ChevronDown"} />

        <h2 className="m-0 p-0 text-left font-semibold text-base text-gray-800">
          {title}
        </h2>
      </button>

      {icon}
    </div>
    <div
      className={classNames(
        "w-full transition-all",
        isOpen ? "max-h-full overflow-visible" : "max-h-0 overflow-hidden",
      )}
    >
      <div className="mt-4 w-full">{children}</div>
    </div>
  </section>
);
